import React from 'react';
import { useSelector } from 'react-redux';
import * as Fi from 'react-icons/fi';
import cn from 'classnames';

import { Select, Form } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

import _ from 'underscore';

const initialState = {
  items: [
    {
      coa: null,
      coa_id: null,
      coa_credit: null,
      coa_debit: null,
    },
  ],
};

export const FormCoaes = ({ data, onChange, loading, transaction, isUseRef }) => {
  const StateForm = useSelector((state) => state?.Form);
  const [{ items }, setState] = React.useState(initialState);

  const isRunMount = React.useRef(isUseRef);

  const dummy = Array.from({ length: 4 }, (v, i) => i);

  const $handleItemsChange = async (i, e, n) => {
    let newItems = [...items];
    if (e?.target?.name) {
      if (e?.target?.valueNumber) {
        newItems[i][e.target.name] = e.target.valueNumber;
      } else {
        newItems[i][e.target.name] = e.target.value;
      }
    } else {
      newItems[i][n] = e;
      newItems[i][`${n}_id`] = e?.id;
    }

    if (n === 'coa' && e === null) {
      newItems[i]['coa_debit'] = null
      newItems[i]['coa_credit'] = null
    }

    setState((prevState) => ({
      ...prevState,
      items: newItems,
    }));
  };

  const $addMoreFields = async (i) => {
    setState((prevState) => ({
      ...prevState,
      items: [
        ...items,
        {
          coa: null,
          coa_id: null,
          coa_credit: null,
          coa_debit: null,
        }
      ],
    }));
  };

  const $removeField = async (i) => {
    let newItems = [...items];
    newItems.splice(i, 1);
    setState((prevState) => ({
      ...prevState,
      items: newItems,
    }));
  };

  const $setCoaWithTransaction = async (transaction) => {
    if (transaction) {
      let p = [];

      const coaes = _.sortBy(transaction?.items, 'type'); // b - a for reverse sort

      coaes?.forEach((i) => {
        console.log(i, "===================")
        if (i?.type === 'D') {
          p.push({
            coa: i?.coa,
            coa_id: i?.coa?.id,
            coa_debit: 1,
            coa_credit: null,
          })
        }

        if (i?.type === 'K') {
          p.push({
            coa: i?.coa,
            coa_id: i?.coa?.id,
            coa_debit: 0,
            coa_credit: 1,
          })
        }
      });

      setState((prevState) => ({ ...prevState, items: p }));
    }

  }

  React.useEffect(() => {
    let newItems = [];

    if (items) {
      items?.forEach((p) => {
        p.nominal = 0

        if (p?.coa_credit) {
          p.nominal = p?.coa_credit
          p.type = 'credit'
        }

        if (p?.coa_debit) {
          p.nominal = p?.coa_debit
          p.type = 'debit'
        }


        newItems.push(p)
      });
    }

    onChange(newItems);
  }, [items]);

  React.useEffect(() => {
    if (!data) return;

    let p = [];
    if (data) {
      data?.coaes?.forEach((i) => {
        let cc = null
        let cd = null

        if (i?.type === 'debit') {
          cd = i?.nominal
        }

        if (i?.type === 'credit') {
          cc = i?.nominal
        }

        p.push({
          id: i?.id,
          coa: i?.coa,
          coa_id: i?.coa?.id,
          coa_credit: cc,
          coa_debit: cd,
        });
      });
    }
    setState((prevState) => ({ ...prevState, items: p }));
  }, [data]);

  React.useEffect(() => {
    if (!data) {
      setState({
        items: [
          {
            coa: null,
            coa_id: null,
            coa_credit: null,
            coa_debit: null,
          },
          {
            coa: null,
            coa_id: null,
            coa_credit: null,
            coa_debit: null,
          },
        ],
      });
    }
  }, []);

  React.useEffect(() => {
    if (isRunMount.current && transaction) {
      isRunMount.current = false
      return
    }

    $setCoaWithTransaction(transaction)
  }, [transaction])

  return (
    <div className="mt-3">
      <div className="fw-semibold py-2 fs-6">Data Coa</div>
      {loading ? (
        <div className="row ">
          {dummy?.map((d, i) => (
            <div className="col-md-3" key={i}>
              <SkeletonsForm count={1} />
            </div>
          ))}
        </div>
      ) : (
        <div className="py-2">
          <table
            width="100%"
            className={cn(
              'table table-vcenter card-table datatable border',
              StateForm?.errors?.orders ? 'border-danger' : ''
            )}
          >
            <thead className="bg-light">
              <tr className="th">
                <td style={{ whiteSpace: 'initial', width: '200px' }}>
                  Coa
                </td>
                <td style={{ whiteSpace: 'initial', width: '200px' }}>
                  Keterangan
                </td>
                <td style={{ whiteSpace: 'initial', width: '100px'}}>
                  Debit
                </td>
                <td style={{ whiteSpace: 'initial', width: '100px'}}>
                  Credit
                </td>
                <td style={{ whiteSpace: 'initial', width: '80px'}}>
                  &nbsp;
                </td>
              </tr>
            </thead>
            <tbody>
              {items?.map((e, i) => (
                <tr
                  key={i}
                  className={cn(
                    StateForm?.errors[`items.${i}.coa_id`]
                    ? 'text-danger border-danger'
                    : null
                  )}
                >
                  <td style={{ whiteSpace: 'initial', width: '200px' }}>
                    <div className="mb-3">
                      <Select.Remote
                        placeholder=""
                        url="/accounting/coa"
                        value={e?.coa_id}
                        initialValue={e?.coa_id}
                        keys={e?.coa_id}
                        row={(d) => {
                          return {
                            value: d?.id,
                            label: d?.code,
                          };
                        }}
                        onSelected={(e) => $handleItemsChange(i, e, 'coa')}
                        errors={
                          StateForm?.errors?.items ||
                          StateForm?.errors[`items.${i}.coa_id`]
                        }
                      />
                    </div>
                  </td>
                  <td style={{ whiteSpace: 'initial', width: '150px' }}>
                    <div className="table-col">
                      <div className="text-ellipsis text-uppercase">
                        {e?.coa?.name}
                      </div>
                    </div>
                  </td>
                  <td style={{ whiteSpace: 'initial', width: '150px' }}>
                    {(e?.coa_credit === 0 || e?.coa_credit === null || e?.coa_credit === '') ? (
                      <Form.Input
                        autoComplete="off"
                        name="coa_debit"
                        type="number"
                        value={e?.coa_debit}
                        onChange={(e) => $handleItemsChange(i, e, 'coa_debit')}
                        error={
                          StateForm?.errors?.items ||
                          StateForm?.errors[`items.${i}.nominal`]
                        }
                      />
                    ): '-'}
                  </td>
                  <td style={{ whiteSpace: 'initial', width: '150px' }}>
                    {(e?.coa_debit === 0 || e?.coa_debit === null || e?.coa_debit === '') ? (
                      <Form.Input
                        autoComplete="off"
                        name="coa_credit"
                        type="number"
                        value={e?.coa_credit}
                        onChange={(e) => $handleItemsChange(i, e, 'coa_credit')}
                        error={
                          StateForm?.errors?.items ||
                          StateForm?.errors[`items.${i}.nominal`]
                        }
                      />
                    ): '-'}
                  </td>
                  <td style={{ whiteSpace: 'initial', width: '80px' }}>
                    <button
                      type="button"
                      className="btn btn-danger rounded mb-3"
                      style={{ minHeight: 30, minWidth: '100%' }}
                      onClick={() => $removeField(i)}
                      disabled={items?.length < 2}
                    >
                      <Fi.FiX />
                    </button>
                  </td>
                </tr>
              ))}
                <tr>
                  <td colSpan={9}>
                    <button
                      type="button"
                      className="btn btn-primary rounded mb-3"
                      style={{ minHeight: 36, minWidth: '100%' }}
                      onClick={() => $addMoreFields()}
                    >
                      <Fi.FiPlus className="me-2" /> Tambah Coa
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
    </div>
  );
};